import { markUserUnblockedInMock } from './users';

// Mock of the «Desbloquear» WRITE: simulate latency, then move the shared users fixture back to
// active with its trace line, so a follow-up searchUsersByPhoneMock returns the unblocked hit and
// the ficha repaints. No error-injection hook, like its write siblings: error-path component tests
// inject a failing fn directly via DI.
export async function unblockUserMock(id: string, reason: string): Promise<void> {
  await new Promise((resolve) => setTimeout(resolve, 100));
  markUserUnblockedInMock(id, reason);
}
